<template>
	<div class="model">
		<!-- 视频遮罩 -->
		<div v-if="showVideo" class="video-mask" @click="skipVideo">
			<video ref="introVideo" class="intro-video" muted playsinline preload="auto" @ended="onVideoEnded"
				@error="onVideoError">
				<!-- <source src="/static/kp.mp4" type="video/mp4" /> -->
				<source src="https://sxchengyioa.oss-cn-chengdu.aliyuncs.com/190/kp.mp4" type="video/mp4" />
			</video>
			<div class="skip-tip">点击跳过开场</div>
		</div>

		<!-- 3D容器：提前渲染、初始动画状态 -->
		<div id="container" class="container" :style="{
			opacity: modelAnimate.opacity,
			transform: `scale(${modelAnimate.scale})`,
			transition: 'opacity 1s ease, transform 1.2s ease'
		}"></div>

		<div class="controls" v-if="menuIndex == 1">
			<button class="btn btn-free active" id="btn-free" @click="switchView('free')">初始视角</button>
			<button class="btn btn-capture" @click="getOptinty">透明模式</button>
			<button class="btn btn-pure" :class="{ active: pureModel }" @click="togglePureModel" v-if="menuIndex === 1">纯净模式</button>
			<!-- <button class="btn btn-capture" @click="captureView" title="转到想要的视角后点此按钮采集当前位置">
			📷 采集视角
			</button> -->
		</div>

		<div class="header flex-between" :style="{ 
			opacity: showContent ? 1 : 0, 
			transition: 'opacity 1s ease'}">
			<div class="flex-colum logo-box">
				<p class="name">智慧园区管理中心</p>
				<p class="english">MANAGEMENT CENTER</p>
			</div>
			<div class="menu-box flex-between">
				<div :class="{'menu-item':true,'last-menu-item':index == 4,'active':menuIndex == index }"
					@click="menuClick(item,index)" v-for="(item,index) in menu" :key="index">
					{{item.label}}
					<img class="active-img" v-if="menuIndex == index" src="@/assets/footer (7).png" alt="" />
				</div>
			</div>
			<div class="flex-start">
				<div class="weather flex-center">
					<span class="icon">☀️</span>
					<div class="temperature">晴 22℃</div>
					<div class="line"></div>
					<div class="time">{{ currentTime }}</div>
				</div>
			</div>
		</div>

		<!-- 左右内容区域 -->
		<div class="content-wrapper" :style="{ opacity: contentVisible ? 1 : 0 }">
			<div class="content-left" :style="{
				transform: contentVisible ? 'translateX(0)' : 'translateX(-100%)',
				opacity: contentVisible ? 1 : 0,
				transition: 'transform 0.8s ease 0.2s, opacity 0.8s ease 0.2s'
			}">
				<template v-if="menuIndex == 0">
					<intro></intro>
				</template>
				<template v-else-if="menuIndex == 1">
					<parkOverviewLeft :footerIndex="footerIndex" @footerIndexChange="footerClick" @areaData="onAreaData"></parkOverviewLeft>
				</template>
				<template v-else-if="menuIndex == 2">
					<deviceManagementLeft></deviceManagementLeft>
				</template>
				<template v-else-if="menuIndex == 3">
					<eventAlertLeft></eventAlertLeft>
				</template>
				<template v-else-if="menuIndex == 4">
					<videoManagement></videoManagement>
				</template>
			</div>

			<div class="content-right" :style="{
				transform: contentVisible ? 'translateX(0)' : 'translateX(100%)',
				opacity: contentVisible ? 1 : 0,
				transition: 'transform 0.8s ease 0.4s, opacity 0.8s ease 0.4s'
			}">
				<template v-if="menuIndex == 1">
					<parkOverviewRight @accessItemClick="onAccessItemClick"></parkOverviewRight>
				</template>
				<template v-else-if="menuIndex == 2">
					<deviceManagementRight></deviceManagementRight>
				</template>
				<template v-else-if="menuIndex == 3">
					<eventAlertRight></eventAlertRight>
				</template>
			</div>
		</div>

		<!-- 设备详情弹框 -->
		<deviceDetailModal
			:visible="deviceModal.visible"
			:deviceInfo="deviceModal.deviceInfo"
			:areaData="areaData"
			@close="deviceModal.visible = false"
			@statusChange="onDeviceStatusChange"
		></deviceDetailModal>
	</div>
</template>

<script>
	import * as THREE from "three";
	import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
	import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
	import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
	import { CSS2DRenderer, CSS2DObject } from "three/examples/jsm/renderers/CSS2DRenderer.js";
	import intro from "./intro.vue"
	import parkOverviewLeft from "./parkOverviewLeft.vue"
	import parkOverviewRight from "./parkOverviewRight.vue"
	import deviceManagementLeft from "./deviceManagementLeft.vue"
	import deviceManagementRight from "./deviceManagementRight.vue"
	import eventAlertLeft from "./eventAlertLeft.vue"
	import eventAlertRight from "./eventAlertRight.vue"
	import videoManagement from "./videoManagement.vue"
	import { releaseTokenGate } from "@/api/request.js"
	import deviceDetailModal from "./modalComponents/deviceDetailModal.vue"
	import wsService from "@/utils/websocketService"

	export default {
		components: {
			intro,
			eventAlertLeft,
			eventAlertRight,
			videoManagement,
			parkOverviewLeft,
			parkOverviewRight,
			deviceManagementLeft,
			deviceManagementRight,
			deviceDetailModal
		},
		data() {
			return {
				opcty:true,
				showVideo: true,
				showContent: false,
				pureModel: false, // 纯净模型模式：隐藏左右内容区，只看 3D 模型
				warnMessages: [], // 实时告警消息列表（来自 WebSocket）
				// 模型初始状态：透明+缩小
				modelAnimate: {
					opacity: 0,
					scale: 0.8
				},
				menuIndex: 0,
				footerIndex: null,
				glowMaterial: null, // "1-ceng-2" 发光材质引用
				cometSystems: [], // 彗星拖尾系统（dixing1/dixing2）
				deviceGlowMats: [], // 设备点位发光材质引用（用于脉冲动画）
				deviceGlowMap: {}, // deviceCode -> { meshes, halos, mats, haloMat }，用于按设备状态改色
				warnGlowHalos: [], // 告警设备红色闪光点（halo mesh）
				warnGlowMats: [], // 告警红色光晕材质引用（用于闪烁动画）
				warnedDeviceCodes: null, // Set：已加红闪的 deviceCode，避免重复
				menu: [{
						key: 0,
						label: "园区介绍"
					},
					{
						key: 1,
						label: "园区总览"
					},
					{
						key: 2,
						label: "设备管理"
					},
					{
						key: 3,
						label: "事件告警"
					},
					{
						key: 4,
						label: "视频管理"
					},
				],
				controls: null,
				scene: null,
				camera: null,
				renderer: null,
				model: null,
				clock: null,
				labelRenderer: null,
				markerAnnotations: [],
				raycaster: null,
				mouse: new THREE.Vector2(),
				hasInitThree: false,
				showBackButton: false,
				// 视角切换
				cameraAnimating: false,
				// 起始（自由）视角相机位置 — 与 initThree 中一致
				initialCameraPos: { x: 25.625982834649232, y: 30.2005106109375, z: 48.88373827642959 },
				initialTarget: { x: 0, y: 0, z: 0 },
				// 大门视角相机位置
				gateCameraPos: { x: -19.114097538978527, y: 4.826635158339129, z: 29.16932496674768 },
				// 大门视角注视点（target）
				gateTarget: { x: -17.01871810369839, y: -0.32266562989411657, z: -0.31107676753174834 },
				// 天台视角相机位置
				tiantaiCameraPos: { x: -34.53452864240305, y: 19.777757255788657, z: -5.652786786982551 },
				// 天台视角注视点（target）
				tiantaiTarget: { x: -15.748885887264729, y: -2.239539803347268, z: -2.1944037945921453 },
				// 机房视角
				jifangCameraPos: { x: -5.509979332107947, y: 8.281339018966763, z: 1.726325594827634 },
				jifangTarget: { x: -5.603177967516014, y: 4.802871665946352, z: -3.4730494493670965 },
				// 库房视角
				kufangCameraPos: { x: -2.025026775146308, y: 6.351859719402868, z: 9.059306161367383 },
				kufangTarget: { x: -2.2004827667894107, y: 1.337893068866398, z: -0.729050720781397 },
				// 泵房视角
				bengfangCameraPos: { x: 14.787290585110195, y: 11.687560512912107, z: -8.581314648609428 },
				bengfangTarget: { x: 13.63579610436032, y: -2.409657736431756, z: -3.6992035258098745 },
				// 实时时间
				currentTime: '',
				timeTimer: null,
				// area_overview 数据（来自 parkOverviewLeft）
				areaData: null,
				// 待选中的区域名（areaData 未加载时点标注点，先记下，数据到了再设 footerIndex）
				pendingAreaName: null,
				// 设备详情弹框
				deviceModal: {
					visible: false,
					deviceInfo: {}
				},
				// mesh name → 设备信息映射表
				// type: 'camera' 摄像头 | 'sensor' 传感器
				// matchKey: 摄像头用，模糊匹配 camera_list 的 deviceName
				// deviceCode: 传感器用，匹配 areaData factors 的 deviceCode
				deviceMeshMap: {
					// ===== 摄像头 =====
					'sxt014': { type: 'camera', label: '停车场摄像头', matchKey: '停车场' },
					'sxt015': { type: 'camera', label: '大门入口摄像头', matchKey: '大门' },
					'网格318_4': { type: 'camera', label: '天台摄像头', matchKey: '天台' },
					'sxt008': { type: 'camera', label: '2楼迁改组走廊摄像头', matchKey: '迁改' },
					'sxt009': { type: 'camera', label: '2楼迁改办公室摄像头', matchKey: '迁改' },
					'sxt001': { type: 'camera', label: '机房摄像头', matchKey: '机房' },
					'sxt010': { type: 'camera', label: '机房摄像头', matchKey: '机房' },
					'sxt011': { type: 'camera', label: '2楼中间走廊摄像头', matchKey: '走廊' },
					'sxt013': { type: 'camera', label: '2楼运维办公区摄像头', matchKey: '运维' },
					'sxt012': { type: 'camera', label: '2楼运维走廊摄像头', matchKey: '运维' },
					'sxt': { type: 'camera', label: '餐厅摄像头', matchKey: '餐厅' },
					'sxt002': { type: 'camera', label: '仓库2摄像头', matchKey: '仓库' },
					'sxt003': { type: 'camera', label: '仓库4摄像头', matchKey: '仓库' },
					'sxt004': { type: 'camera', label: '仓库3摄像头', matchKey: '仓库' },
					'sxt005': { type: 'camera', label: '仓库1摄像头', matchKey: '仓库' },
					'sxt006': { type: 'camera', label: '前台摄像头', matchKey: '前台' },
					'sxt007': { type: 'camera', label: '水泵房摄像头', matchKey: '泵房' },
					// ===== 传感器 =====
					'fdwssq-cgq': { type: 'sensor', label: '非定位式水浸传感器', deviceCode: 'jd_water_0B_1_6050' },
					'fx-cgq': { type: 'sensor', label: '风向传感器', deviceCode: 'jd_windDdirection_02_1_6050' },
					'fs-cgq': { type: 'sensor', label: '风速传感器', deviceCode: 'jd_windSpeed_0E_1_6050' },
					'sfdyl-cgq': { type: 'sensor', label: '双翻斗雨量传感器', deviceCode: 'jd_rain_14_1_6050' },
					'tyzfs-cgq': { type: 'sensor', label: '太阳总辐射传感器', deviceCode: 'os_radiation_07_1_6050' },
					'trjcy': { type: 'sensor', label: '土壤监测器', deviceCode: 'os_soil_06_1_6050' },
					'ddtcld-cgq': { type: 'sensor', label: '跌倒探测雷达传感器', deviceCode: 'wt_tumble_12_1_6050' },
					'wsd-cgq': { type: 'sensor', label: '温湿度传感器', deviceCode: 'jd_tempHumidity_0F_1_6050' },
					'yw-cgq001': { type: 'sensor', label: '烟雾传感器', deviceCode: 'jd_smoke_09_1_6050' },
					'rt-cgq002': { type: 'sensor', label: '人体传感器', deviceCode: 'zt_motion_01_1_6050' },
					'rt-cgq001': { type: 'sensor', label: '人体传感器', deviceCode: 'zt_motion_01_1_6050' },
					'co2-cgq': { type: 'sensor', label: '二氧化碳传感器', deviceCode: 'jd_co2_05_1_6050' },
					'yw-cgq': { type: 'sensor', label: '烟雾传感器', deviceCode: 'jd_smoke_09_1_6050' },
					'rt-cgq': { type: 'sensor', label: '人体传感器', deviceCode: 'zt_motion_01_1_6050' },
					'trsyw-cgq': { type: 'sensor', label: '投入式液位传感器', deviceCode: 'wt_waterLevel_0D_1_6050' }
				}
			};
		},
		created() {
			this.queryToken();
			setTimeout(() => {
				if (this.showVideo) {
					console.warn("视频超时，强制跳过");
					this.skipVideo();
				}
			}, 15000);
		},
		mounted() {
			this.$nextTick(() => {
				this.initThree();
				this.tryPlayVideo();
			});
			window.addEventListener('resize', this.onWindowResize);
			// 实时时间
			this.updateTime();
			this.timeTimer = setInterval(this.updateTime, 1000);
		},
	beforeDestroy() {
		const container = document.getElementById("container");
		if (container) {
			container.removeEventListener('click', this.onAnnotationClick);
		}
		window.removeEventListener('resize', this.onWindowResize);
		if (this.timeTimer) clearInterval(this.timeTimer);
		if (this.renderer) this.renderer.dispose();
		if (this.scene) this.scene.clear();
		// 解除实时告警 WebSocket 回调（不主动关闭连接，单例由各组件共享）
		wsService.unsubscribeWarn(this.handleWarnMessage);
	},
	computed: {
		// 左右内容区是否可见：入场动画完成 且 非纯净模型模式
		contentVisible() {
			return this.showContent && !this.pureModel;
		}
	},
	methods: {
		async queryToken() {
			// 失败重试多次，避免一次性网络抖动导致页面无数据
			let tokenGot = false;
			for (let i = 0; i < 3; i++) {
				try {
					let res = await this.$http.post(this.$api.BASE_URL_Category.queryToken, {
						organizational: "S7F7AUINNURSQXUK",
						secret: "RHMYHSQHJR/1MHS8"
					});
					// res 已由响应拦截器返回为 response.data（HTTP body）
					// 兼容 { data: { authorization, accessToken } } 与平铺 { authorization, accessToken } 两种结构
					const body = res && res.data ? res.data : res;
					if (body && (body.authorization || body.accessToken)) {
						localStorage.setItem('authorization', body.authorization)
						localStorage.setItem('token', body.accessToken)
						tokenGot = true;
						this.initWarnWebSocket();
						break;
					} else {
						console.error('获取 token 失败：响应结构不匹配', res);
					}
				} catch (e) {
					console.error('获取 token 失败，重试 ' + (i + 1) + '/3:', e);
				}
			}
			if (!tokenGot) {
				this.$message && this.$message.error('获取登录凭证失败，请刷新页面重试');
			}
			releaseTokenGate();
	},
	initWarnWebSocket() {
		wsService.initWarnWs(this.handleWarnMessage);
	},
	// 实时告警消息回调
	handleWarnMessage(data) {
		console.log('[model.vue] 实时告警:', data);
		// 暂存到列表头部，保留最近 50 条
		this.warnMessages.unshift(data);
		if (this.warnMessages.length > 50) {
			this.warnMessages.length = 50;
		}
		// 新增告警：给对应设备模型加红色闪光点
		if (data && data.msgType === 'WARN_CREATED' && Array.isArray(data.payload)) {
			for (const item of data.payload) {
				if (item && item.deviceCode) {
					this.addWarnGlow(item.deviceCode);
				}
			}
		}
	},
	// 给指定 deviceCode 对应的模型加红色闪光点（halo 球）
	// deviceMeshMap 是 meshName -> { deviceCode }，这里反向查找
	addWarnGlow(deviceCode) {
		if (!this.model || !this.scene) return;
		if (!this.warnedDeviceCodes) this.warnedDeviceCodes = new Set();
		if (this.warnedDeviceCodes.has(deviceCode)) return; // 已加红闪，跳过
		this.warnedDeviceCodes.add(deviceCode);

		// 反向映射：deviceCode -> [meshName, ...]（同一 deviceCode 可能对应多个 mesh name）
		const meshNames = [];
		for (const name in this.deviceMeshMap) {
			if (this.deviceMeshMap[name].deviceCode === deviceCode) {
				meshNames.push(name);
			}
		}
		if (!meshNames.length) {
			console.warn('[addWarnGlow] deviceMeshMap 中未找到 deviceCode:', deviceCode);
			return;
		}

		// 红色光晕材质（additive blending）— 纯红 0xff0000
		const warnColor = new THREE.Color(0xff0000);
		const warnHaloMat = new THREE.MeshBasicMaterial({
			color: warnColor,
			transparent: true,
			opacity: 1.0,
			blending: THREE.AdditiveBlending,
			depthWrite: false,
			side: THREE.DoubleSide,
			toneMapped: false // 绕过 ACES tone mapping，颜色保持原值
		});

		// 遍历模型，找到所有名字命中 meshNames 的 mesh
		const hitMeshes = [];
		this.model.traverse((child) => {
			if (!child.isMesh) return;
			if (meshNames.indexOf(child.name) === -1) return;
			hitMeshes.push(child);
		});

		for (const mesh of hitMeshes) {
			mesh.geometry.computeBoundingBox();
			const box = mesh.geometry.boundingBox;
			const size = new THREE.Vector3();
			box.getSize(size);
			// 半径与 mesh 一致（和蓝色光晕球保持一致）
			const radius = Math.max(size.x, size.y, size.z) * 0.5;
			const haloGeo = new THREE.SphereGeometry(Math.max(radius, 0.15), 20, 20);
			const halo = new THREE.Mesh(haloGeo, warnHaloMat);
			const worldPos = new THREE.Vector3();
			mesh.getWorldPosition(worldPos);
			halo.position.copy(worldPos);
			// 告警红闪始终显示（不受透明模式开关影响）
			halo.visible = true;
			this.scene.add(halo);
			this.warnGlowHalos.push(halo);
		}

		// 红色材质加入闪烁动画列表（多个 halo 共享同一材质，只 push 一次）
		this.warnGlowMats.push(warnHaloMat);

		if (!hitMeshes.length) {
			console.warn('[addWarnGlow] 模型中未找到对应 mesh:', meshNames);
		} else {
			console.log('[addWarnGlow] 已为设备加红闪:', deviceCode, '->', hitMeshes.map(m => m.name));
		}
	},
	updateTime() {
			const d = new Date();
			const pad = (n) => String(n).padStart(2, '0');
			this.currentTime = `${d.getFullYear()}/${pad(d.getMonth()+1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
		},
		// parkOverviewLeft 获取到 area 数据后回调
		onAreaData(data) {
			this.areaData = data;
			this.updateAnnotationColors();
			// 从 area.devices[] 构建 deviceCode -> status 映射，驱动设备发光点颜色（在线绿/异常红）
			const statusMap = {};
			if (data && data.areas) {
				for (const area of data.areas) {
					if (Array.isArray(area.devices)) {
						for (const d of area.devices) {
							if (d.deviceCode) statusMap[d.deviceCode] = d.status;
						}
					}
				}
			}
			this.applyDeviceStatusColors(statusMap);
			// 处理"areaData 未加载时点标注点"的待选中区域
			if (this.pendingAreaName && data && data.areas) {
				const area = data.areas.find(a => a.areaName === this.pendingAreaName);
				if (area) this.footerIndex = area.areaId;
				this.pendingAreaName = null;
			}
		},
		// 根据 area.devices[].status 更新标注点颜色（status: 1在线 2故障 3告警 4离线）
		// 区域内存在故障/告警/离线设备则视为异常 → 红色，否则正常 → 蓝色
		updateAnnotationColors() {
			if (!this.areaData || !this.areaData.areas || !this.markerAnnotations.length) return;
			for (const ann of this.markerAnnotations) {
				const area = this.areaData.areas.find(a => a.areaName === ann.name);
				if (!area) continue;
				const isAbnormal = Array.isArray(area.devices) &&
					area.devices.some(d => ['2', '3', '4'].includes(String(d.status)));
				const colorHex = isAbnormal ? '#ff4444' : '#4aa7ff';
				const color = new THREE.Color(colorHex);
				// 虚线材质
				if (ann.poleMat) ann.poleMat.color = color;
				// 底座环材质
				if (ann.ringMat) {
					ann.ringMat.color = color;
					ann.ringMat.emissive = color;
				}
				// 标签卡片边框
				if (ann.cardDiv) ann.cardDiv.style.borderColor = colorHex;
				// 状态文字
				if (ann.dataDiv) {
					ann.dataDiv.textContent = isAbnormal ? '异常' : '正常';
					ann.dataDiv.style.color = colorHex;
				}
			}
		},
		// 加载所有传感器设备的实时状态（并行调 latest-data），数据返回即按状态设色，无需点击
		loadAllDeviceStatus() {
			// 收集 deviceMeshMap 里所有唯一 deviceCode（摄像头无 deviceCode，跳过）
			const codes = [];
			const seen = {};
			for (const name in this.deviceMeshMap) {
				const code = this.deviceMeshMap[name].deviceCode;
				if (code && !seen[code]) {
					seen[code] = true;
					codes.push(code);
				}
			}
			if (!codes.length) return;
			Promise.all(codes.map(code =>
				this.$http.get(this.$api.BASE_URL_Category.latDataCode, { deviceCode: code })
					.then(res => ({ code, data: (res && res.data) || null }))
					.catch(() => ({ code, data: null }))
			)).then(results => {
				const statusMap = {};
				for (const r of results) {
					if (r.data && r.data.status !== undefined) {
						statusMap[r.code] = r.data.status;
					}
				}
				this.applyDeviceStatusColors(statusMap);
			});
		},
		// 根据设备状态（deviceCode -> status）批量给设备发光点设色：在线绿 / 故障(2)、告警(3)、离线(4)红
		applyDeviceStatusColors(statusMap) {
			if (!this.deviceGlowMap || !statusMap) return;
			for (const code in this.deviceGlowMap) {
				if (code.indexOf('#') === 0) continue; // 无 deviceCode 的摄像头兜底 key，跳过
				const entry = this.deviceGlowMap[code];
				const status = statusMap[code];
				if (status === undefined) continue; // 状态未知，保持默认绿
				this.setDeviceGlowColor(entry, status);
			}
		},
		// 单个设备发光点改色（area-overview 全量驱动 与 点击弹框兜底 共用）
		setDeviceGlowColor(entry, status) {
			if (!entry) return;
			const isAbnormal = ['2', '3', '4'].includes(String(status));
			const color = isAbnormal ? 0xff0000 : 0x00ff00;
			if (entry.haloMat && entry.haloMat.color) {
				entry.haloMat.color.setHex(color);
				entry.haloMat.needsUpdate = true;
			}
			for (const m of entry.mats) {
				if (m.isMeshBasicMaterial) {
					m.color.setHex(color);
				} else if (m.emissive) {
					m.emissive.setHex(color);
				}
				m.needsUpdate = true;
			}
		},
		// 点击设备弹框拿到最新状态后回调（单设备即时兜底更新）
		onDeviceStatusChange(payload) {
			if (!payload || !payload.deviceCode) return;
			const entry = this.deviceGlowMap && this.deviceGlowMap[payload.deviceCode];
			if (!entry) return;
			this.setDeviceGlowColor(entry, payload.status);
		},
			tryPlayVideo() {
				const video = this.$refs.introVideo;
				if (!video) return;
				video.muted = true;
				video.playsInline = true;
				video.preload = "auto";
				video.play().then(() => {
					console.log("视频播放成功");
				}).catch(err => {
					console.warn("视频自动播放被拦截:", err);
					this.skipVideo();
				});
				const handleUserClick = () => {
					video.play().catch(() => {});
					document.removeEventListener("click", handleUserClick);
				};
				document.addEventListener("click", handleUserClick);
			},

			onVideoEnded() {
				this.skipVideo();
			},

			onVideoError(e) {
				console.error("视频加载错误:", e);
				this.skipVideo();
			},

			// 【核心修复】无缝衔接：先开启动画，再隐藏视频，消除黑屏
			skipVideo() {
				// 1. 立即执行3D模型入场动画（和视频淡出并行）
				this.modelAnimate.opacity = 1;
				this.modelAnimate.scale = 1;

				// 2. 紧接着开启左右UI动画，极小延迟保证层级顺滑
				setTimeout(() => {
					this.showContent = true;
				}, 100);
				// 3. 视频延迟一点点消失，和模型动画重叠，彻底杜绝黑屏
				setTimeout(() => {
					this.showVideo = false;
					const video = this.$refs.introVideo;
					if (video) {
						video.pause();
						video.src = "";
					}
				}, 200);
			},

			initThree() {
				// if (this.hasInitThree) return;
				const container = document.getElementById("container");
				// if (!container) return;
				const w = container.clientWidth;
				const h = container.clientHeight;

				this.scene = new THREE.Scene();
				this.scene.background = new THREE.Color(0x1a1a2e);
				this.camera = new THREE.PerspectiveCamera(45, w / h, 0.1, 1000);
				this.camera.position.set(25.625982834649232, 30.2005106109375, 48.88373827642959);
				this.camera.lookAt(0, 0, 0);

				const ambientLight = new THREE.AmbientLight(0xffffff, 1);
				this.scene.add(ambientLight);
				const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
				directionalLight.position.set(30, 50, 30);
				directionalLight.lookAt(0, 0, 0);
				this.scene.add(directionalLight);
				// 底部补光，减少暗面
				const fillLight = new THREE.DirectionalLight(0x6688cc, 0.5);
				fillLight.position.set(-20, -10, -20);
				fillLight.lookAt(0, 0, 0);
				this.scene.add(fillLight);

				this.renderer = new THREE.WebGLRenderer({
					antialias: true,
					alpha: true,
				});
				this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
				this.renderer.toneMappingExposure = 1.3;
				this.renderer.setSize(w, h);
				this.renderer.setPixelRatio(window.devicePixelRatio);
				container.appendChild(this.renderer.domElement);

				// CSS2D 渲染器 — 用于3D文字标注
				this.labelRenderer = new CSS2DRenderer();
				this.labelRenderer.setSize(w, h);
				this.labelRenderer.domElement.style.position = 'absolute';
				this.labelRenderer.domElement.style.top = '0';
				this.labelRenderer.domElement.style.left = '0';
				this.labelRenderer.domElement.style.pointerEvents = 'none';
				container.appendChild(this.labelRenderer.domElement);

				// HDR 环境光
				const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
				pmremGenerator.compileEquirectangularShader();
				new RGBELoader()
					.setDataType(THREE.HalfFloatType)
					.load('/static/venice_sunset_1k.hdr', (texture) => {
						const envMap = pmremGenerator.fromEquirectangular(texture).texture;
						this.scene.environment = envMap;
						this.scene.environmentIntensity = 1.6;
						texture.dispose();
						// console.log('✅ HDR 环境光已加载');
					}, undefined, (err) => {
						console.error('HDR 加载失败:', err);
					});
				this.controls = new OrbitControls(this.camera, this.renderer.domElement);
				this.controls.maxPolarAngle = Math.PI / 2;
				this.controls.enableZoom = true;
				// 新增：限制缩放范围，防止看到模型边缘
				this.controls.minDistance = 1; // 最小缩放距离（数值越大，模型看起来越大）
				this.controls.maxDistance = 80; // 最大缩放距离（数值越小，模型看起来越小）
				this.controls.target.set(0, 0, 0);
				this.controls.update();

				// 射线检测 — 用于标注点击
				this.raycaster = new THREE.Raycaster();
				container.addEventListener('click', this.onAnnotationClick, false);

				this.clock = new THREE.Clock();
				this.hasInitThree = true;

				const loader = new GLTFLoader();
				loader.load(
					'https://sxchengyioa.oss-cn-chengdu.aliyuncs.com/190/shenzheng.glb',
					// "/static/shenzheng.glb",
					(gltf) => {
						this.model = gltf.scene;
						this.model.scale.set(0.7, 0.7, 0.7);
						this.model.position.set(0, 0, 0);
						this.scene.add(this.model);
						// 【调试】列出模型所有 mesh 名称
						// this.model.traverse(child => {
						// 	console.log(" mesh name:", child.name);
						// });
						this.addGlowToMesh("1-ceng-2", 0x00ccff, 1.2);
						this.addCometTrails("dixing1", {
							color: 0x66ccff,
							lightCount: 350,
							lightLen: 0.12,
							speed: 0.50,
							xyOff: { x: 0, y: 0 }
						});
						this.addCometTrails("dixing2", {
							color: 0x3399ff,
							lightCount: 350,
							lightLen: 0.12,
							speed: 0.40,
							xyOff: { x: 0, y: 0 }
						});
					this.addFenceWall("1-ceng-2", {
						color: 0x4488ff,
						wallRatio: 0.04,
						opacity: 0.6,
						padX: 3.0,    // X 方向（长度）
						padY: 8.0     // Y 方向（宽度）
					});
					// — 3个建筑标注点 —
					this.addAnnotationMarker(
						new THREE.Vector3(-10, 11, 2),
						'主机房',
						'#4aa7ff'
					);
					this.addAnnotationMarker(
						new THREE.Vector3(-4,11, 6),
						'仓库',
						'#4aa7ff'
					);
					this.addAnnotationMarker(
						new THREE.Vector3(23, 11, -5),
						'泵房',
						'#4aa7ff'
					);
					this.addAnnotationMarker(
						new THREE.Vector3(-34, 11, -5),
						'天台',
						'#4aa7ff'
					);
					this.addAnnotationMarker(
						new THREE.Vector3(-30, 0, 19),
						'园区大门',
						'#4aa7ff'
					);
					this.animate();
					// 标注点全部创建完，如果 area 数据已先到，补调一次颜色更新（解决时序问题）
					if (this.areaData) this.updateAnnotationColors();
					this.addDeviceGlow();
					// 加载所有设备状态，数据返回即按状态设色（无需点击）
					this.loadAllDeviceStatus();
						// this.controls.addEventListener("change", () => {
						// 	console.log(
						// 		`Camera Position: x=${this.camera.position.x}, y=${this.camera.position.y}, z=${this.camera.position.z}`
						// 	);
						// 	console.log(
						// 		`Controls Target: x=${this.controls.target.x}, y=${this.controls.target.y}, z=${this.controls.target.z}`
						// 	);
						// });
					},
					undefined,
					(err) => {
						console.error("模型加载失败:", err);
					}
				);
			},
			animate() {
				if (!this.hasInitThree) return;
				requestAnimationFrame(() => this.animate());
				// "1-ceng-2" 发光脉冲动画
				if (this.glowMaterial) {
					const pulse = Math.sin(Date.now() * 0.002) * 0.3 + 0.7;
					this.glowMaterial.emissiveIntensity = pulse;
				}
		// 设备点位发光：只在透明模式下显示绿色常亮（!this.opcty）
		if (this.deviceGlowMats.length) {
			if (!this.opcty) {
				// 透明模式：绿色发光常亮
				for (const m of this.deviceGlowMats) {
					if (m.isMeshBasicMaterial) {
						m.opacity = 1.0;
					} else if ('emissiveIntensity' in m) {
						m.emissiveIntensity = 2.0;
					}
				}
			} else {
				// 非透明模式：关闭发光
				for (const m of this.deviceGlowMats) {
					if (m.isMeshBasicMaterial) {
						m.opacity = 0;
					} else if ('emissiveIntensity' in m) {
						m.emissiveIntensity = 0;
					}
				}
			}
		}
			// 告警设备红色闪光点：快速明灭（0~1），比蓝色更急促
			if (this.warnGlowMats.length) {
				// 用 abs(sin) 做急促闪烁，频率比蓝色高
				const flash = Math.abs(Math.sin(Date.now() * 0.012));
				// 加一个阈值，让"灭"的瞬间更明显（接近 0 才真灭）
				const flashVal = flash < 0.2 ? 0 : flash;
				for (const m of this.warnGlowMats) {
					m.opacity = flashVal;
				}
			}
				// 跑马灯动画：Line 每帧更新位置+颜色
				for (const cs of this.cometSystems) {
					const { lightLen, lightVerts, zOff, baseColor, lights } = cs;
					for (const li of lights) {
						li.progress += li.speed;
						if (li.progress > 1) li.progress -= 1;
						if (li.progress < 0) li.progress += 1;

						const pos = li.geo.attributes.position.array;
						const col = li.geo.attributes.color.array;
						for (let i = 0; i < lightVerts; i++) {
							const t = li.progress + (i / (lightVerts - 1) - 0.5) * lightLen;
							const pt = li.loopPos(t);
							pos[i*3]   = pt.x;
							pos[i*3+1] = pt.y;
							pos[i*3+2] = pt.z + zOff;
							const d = Math.abs(i / (lightVerts - 1) - 0.5) * 2;
							const b = Math.pow(1 - d, 2.5);
							col[i*3]   = baseColor.r * b;
							col[i*3+1] = baseColor.g * b;
							col[i*3+2] = baseColor.b * b;
						}
						li.geo.attributes.position.needsUpdate = true;
						li.geo.attributes.color.needsUpdate = true;
					}
				}
			if (this._fenceMats) {
				const scanY = (Math.sin(performance.now() * 0.0015) * 0.5 + 0.5);
				for (const m of this._fenceMats) m.uniforms.uScanY.value = scanY;
			}
			// 标注点脉冲动画已移除（圆球已去掉）
			if (this.controls) this.controls.update();
				if (this.scene && this.camera && this.renderer) {
					this.renderer.render(this.scene, this.camera);
				}
				if (this.scene && this.camera && this.labelRenderer) {
					this.labelRenderer.render(this.scene, this.camera);
				}
			},

			onWindowResize() {
				const container = document.getElementById("container");
				if (!container || !this.camera || !this.renderer) return;
				const w = container.clientWidth;
				const h = container.clientHeight;
				this.camera.aspect = w / h;
				this.camera.updateProjectionMatrix();
				this.renderer.setSize(w, h);
				if (this.labelRenderer) {
					this.labelRenderer.setSize(w, h);
				}
			},

			addGlowToMesh(name, color, intensity) {
				this.model.traverse((child) => {
					if (child.isMesh && child.name === name) {
						if (Array.isArray(child.material)) {
							child.material = child.material.map(mat => {
								const m = mat.clone();
								m.emissive = new THREE.Color(color);
								m.emissiveIntensity = intensity;
								return m;
							});
						} else {
							const mat = child.material.clone();
							mat.emissive = new THREE.Color(color);
							mat.emissiveIntensity = intensity;
							child.material = mat;
							this.glowMaterial = mat;
						}
						// console.log(`✅ 已为 "${name}" 添加发光效果`);
					}
				});
			},

			// 给所有设备点位 mesh 加发光效果（脉冲呼吸），并按 deviceCode 分组建立映射，供状态改色
			addDeviceGlow() {
				if (!this.model) return;
				const glowColor = new THREE.Color(0x00ff00); // 纯绿（默认在线状态色）
				const baseIntensity = 2.0;
				// 所有需要发光的设备点位 mesh name
				const deviceNames = [
					'sxt014','sxt015','sxt008','sxt009','sxt001','sxt010','sxt011','sxt013','sxt012',
					'sxt','sxt002','sxt003','sxt004','sxt005','sxt006','sxt007',
					'fdwssq-cgq','fx-cgq','fs-cgq','sfdyl-cgq','tyzfs-cgq','trjcy',
					'ddtcld-cgq','wsd-cgq','yw-cgq001','rt-cgq002','rt-cgq001',
					'co2-cgq','yw-cgq','rt-cgq','trsyw-cgq'
				];
				const found = {};
				// deviceCode -> [mesh, ...]；无 deviceCode 的（摄像头）用 '#'+name 兜底 key
				const meshesByKey = {};
				this.model.traverse((child) => {
					if (deviceNames.indexOf(child.name) === -1) return;
					if (!child.isMesh) return;
					const info = this.deviceMeshMap[child.name];
					const code = info && info.deviceCode ? info.deviceCode : null;
					const key = code || ('#' + child.name);
					if (!meshesByKey[key]) meshesByKey[key] = [];
					meshesByKey[key].push(child);
					found[child.name] = (found[child.name] || 0) + 1;
				});

				// 按 key 分组，每个 key 用独立的发光材质 + 光晕材质，方便按状态单独改色
				this.deviceGlowMap = {};
				for (const key in meshesByKey) {
					const meshes = meshesByKey[key];
					// 独立光晕材质（共享材质无法单独改某个设备的颜色）
					const haloMat = new THREE.MeshBasicMaterial({
						color: glowColor.clone(),
						transparent: true,
						opacity: 1.0,
						blending: THREE.AdditiveBlending,
						depthWrite: false,
						side: THREE.DoubleSide,
						toneMapped: false // 绕过 ACES tone mapping，颜色保持原值不偏紫
					});
					const entry = { meshes, halos: [], mats: [], haloMat };

					for (const mesh of meshes) {
						const handleMat = (mat) => {
							const m = mat.clone();
							if (m.isMeshBasicMaterial) {
								m.color = glowColor.clone();
								m.toneMapped = false;
							} else {
								m.emissive = glowColor.clone();
								m.emissiveIntensity = baseIntensity;
								m.toneMapped = false;
							}
							m.needsUpdate = true;
							entry.mats.push(m);
							this.deviceGlowMats.push(m);
							return m;
						};
						if (Array.isArray(mesh.material)) {
							mesh.material = mesh.material.map(handleMat);
						} else {
							mesh.material = handleMat(mesh.material);
						}

						// 外发光光晕球：用 boundingbox 估算半径，与模型自身大小一致
						mesh.geometry.computeBoundingBox();
						const box = mesh.geometry.boundingBox;
						const size = new THREE.Vector3();
						box.getSize(size);
						const radius = Math.max(size.x, size.y, size.z) * 0.5;
						const haloGeo = new THREE.SphereGeometry(Math.max(radius, 0.15), 16, 16);
						const halo = new THREE.Mesh(haloGeo, haloMat);
						const worldPos = new THREE.Vector3();
						mesh.getWorldPosition(worldPos);
						halo.position.copy(worldPos);
						// 默认隐藏，只在透明模式（!this.opcty）下显示
						halo.visible = !this.opcty;
						this.scene.add(halo);
						entry.halos.push(halo);
						this.deviceGlowHalos = this.deviceGlowHalos || [];
						this.deviceGlowHalos.push(halo);
					}
					// 光晕材质加入脉冲列表（每个 key 一个 haloMat）
					this.deviceGlowMats.push(haloMat);
					this.deviceGlowMap[key] = entry;
				}

				const notFound = deviceNames.filter(n => !found[n]);
				if (notFound.length) {
					console.warn('[addDeviceGlow] 未找到以下 mesh:', notFound);
				}
			},

			// 跑马灯：串联边框→暗底轮廓线 + 多条亮色流动光段
			addCometTrails(meshName, options = {}) {
				try {
					const opts = Object.assign({
						color: 0x66ccff,
						lightCount:  4,       // 同时跑的光段数
						lightLen:    0.08,    // 每段占环周长的比例
						lightVerts:  40,      // 每段光条的顶点数（越多越平滑）
						speed:       0.6,
						baseOpacity: 0.15,    // 底色轮廓的透明度
						zOffset:     1.5,     // Z 轴向上偏移
						xyOff:       { x: 0, y: 0 }  // XY 微调偏移
					}, options);

					// 1. 定位 mesh
					let targetMesh = null;
					this.model.traverse(c => { if (c.isMesh && c.name === meshName) targetMesh = c; });
					if (!targetMesh) { console.warn(`⚠️ 未找到 mesh: "${meshName}"`); return; }
					// console.log(` "${meshName}" 已定位`);

					// 2. 提取边并串环
					const edges = new THREE.EdgesGeometry(targetMesh.geometry);
					const pos = edges.attributes.position.array;
					const segCount = pos.length / 6;
					if (segCount < 3) return;

					// 构建边对象（含容错顶点键）
					const snapV = v => {
						const s = 0.005;
						return `${Math.round(v.x/s)*s},${Math.round(v.y/s)*s},${Math.round(v.z/s)*s}`;
					};
					const edgeObjs = [];
					for (let i = 0; i < segCount; i++) {
						const i1 = i * 6, i2 = i * 6 + 3;
						edgeObjs.push({
							v1: new THREE.Vector3(pos[i1], pos[i1+1], pos[i1+2]),
							v2: new THREE.Vector3(pos[i2], pos[i2+1], pos[i2+2]),
							used: false
						});
					}

					// 邻接表
					const adj = new Map();
					for (const e of edgeObjs) {
						[snapV(e.v1), snapV(e.v2)].forEach(k => {
							if (!adj.has(k)) adj.set(k, []);
							adj.get(k).push(e);
						});
					}

					// 追踪环
					function traceLoop(start) {
						const loop = [start.v1.clone()];
						start.used = true;
						let cur = start.v2;
						const startKey = snapV(start.v1);
						let steps = 0;
						while (steps++ < edgeObjs.length + 5) {
							const pool = adj.get(snapV(cur)) || [];
							const next = pool.find(e => !e.used);
							if (!next) break;
							next.used = true;
							const nxt = snapV(next.v1) === snapV(cur) ? next.v2 : next.v1;
							loop.push(nxt.clone());
							cur = nxt;
							if (snapV(cur) === startKey) break;
						}
						return loop;
					}

					const loops = [];
					for (const e of edgeObjs) {
						if (!e.used) {
							const lp = traceLoop(e);
							lp.pop();
							if (lp.length >= 3) loops.push(lp);
						}
					}
					loops.sort((a, b) => b.length - a.length);
					const validLoops = loops.filter(lp => lp.length >= 3);
					if (validLoops.length === 0) {
						// console.warn(`⚠️ "${meshName}" 无有效环，跳过`);
						return;
					}
					// console.log(` "${meshName}" ${segCount}段边 → ${loops.length}环，有效=${validLoops.length}`);

					const zOff = opts.zOffset;
					const baseColor = new THREE.Color(opts.color);
					const { lightCount, lightLen, lightVerts, xyOff } = opts;
					const allLights = [];

					// 串环 → 连续路径 → 连续跑动光条
					for (const mainLoop of validLoops) {
						if (mainLoop.length < 3) continue;
						const arc = [0];
						for (let i = 0; i < mainLoop.length; i++) {
							const nxt = mainLoop[(i+1) % mainLoop.length];
							arc.push(arc[i] + mainLoop[i].distanceTo(nxt));
						}
						const totalArc = arc[arc.length - 1];
						if (totalArc < 0.01) continue;

						function loopPos(t) {
							t = ((t % 1) + 1) % 1;
							const target = t * totalArc;
							let lo = 0, hi = arc.length - 1;
							while (lo < hi - 1) { const m = (lo+hi)>>1; arc[m] <= target ? lo=m : hi=m; }
							const seg = arc[hi] - arc[lo];
							const r = seg > 0 ? (target - arc[lo]) / seg : 0;
							const v = new THREE.Vector3().lerpVectors(mainLoop[lo % mainLoop.length], mainLoop[hi % mainLoop.length], r);
							v.x += xyOff.x;
							v.y += xyOff.y;
							return v;
						}

						const lightsForThis = Math.max(3, Math.round(lightCount * totalArc / validLoops.reduce((s,lp) => {
							let a=0; for(let i=0;i<lp.length;i++) a+=lp[i].distanceTo(lp[(i+1)%lp.length]); return s+a;
						}, 0)));

						for (let i = 0; i < lightsForThis; i++) {
							const geo = new THREE.BufferGeometry();
							const lv = new Float32Array(lightVerts * 3);
							const lc = new Float32Array(lightVerts * 3);
							geo.setAttribute('position', new THREE.BufferAttribute(lv, 3));
							geo.setAttribute('color', new THREE.BufferAttribute(lc, 3));
							const line = new THREE.Line(geo,
								new THREE.LineBasicMaterial({ vertexColors: true, transparent: true, blending: THREE.AdditiveBlending, depthTest: true }));
							targetMesh.add(line);

							allLights.push({
								line, geo,
								loopPos, totalArc,
								progress: Math.random(),
								speed: (0.003 + Math.random() * 0.007) * opts.speed * (Math.random() > 0.5 ? 1 : -1)
							});
						}
					}

					this.cometSystems.push({
						lightLen, lightVerts, zOff, baseColor,
						lights: allLights
					});
					// console.log(`✅ "${meshName}" 跑马灯: ${allLights.length}条光段 (${validLoops.length}环)`);

				} catch (err) {
					console.error(`❌ addCometTrails("${meshName}") 异常:`, err);
				}
			},

			// 电子围栏：包围盒四面矩形光幕墙
			addFenceWall(meshName, options = {}) {
				try {
					const opts = Object.assign({
						color: 0x4488ff,
						wallRatio: 0.03,
						opacity: 0.6,
						padding: 10.0
					}, options);

					let targetMesh = null;
					this.model.traverse(c => { if (c.isMesh && c.name === meshName) targetMesh = c; });
					if (!targetMesh) { console.warn(`⚠️ 围栏未找到: "${meshName}"`); return; }
					// console.log(` "${meshName}" 围栏已定位`);

					if (!targetMesh.geometry.boundingBox) targetMesh.geometry.computeBoundingBox();
					const bb = targetMesh.geometry.boundingBox;
					const padX = opts.padX || opts.padding;
					const padY = opts.padY || opts.padding;
					const x1 = bb.min.x - padX, x2 = bb.max.x + padX;
					const y1 = bb.min.y - padY, y2 = bb.max.y + padY;
					const zBot = bb.min.z + (bb.max.z - bb.min.z) * 0.4;
					let modelMaxZ = bb.max.z;
					this.model.traverse(c => {
						if (c.isMesh) {
							if (!c.geometry.boundingBox) c.geometry.computeBoundingBox();
							modelMaxZ = Math.max(modelMaxZ, c.geometry.boundingBox.max.z);
						}
					});
					const zTop = zBot + (modelMaxZ - zBot) * opts.wallRatio;
					const h = zTop - zBot;
					// console.log(` "${meshName}" 围栏: [${x1.toFixed(1)},${y1.toFixed(1)}]→[${x2.toFixed(1)},${y2.toFixed(1)}] Z${zBot.toFixed(1)}→${zTop.toFixed(1)}`);

					const walls = [
						{ ax: x1, ay: y2, bx: x2, by: y2 },
						{ ax: x2, ay: y1, bx: x1, by: y1 },
						{ ax: x1, ay: y1, bx: x1, by: y2 },
						{ ax: x2, ay: y2, bx: x2, by: y1 },
					];

					const baseColor = new THREE.Color(opts.color);
					const mat = new THREE.ShaderMaterial({
						uniforms: {
							uColor: { value: baseColor },
							uOpacity: { value: opts.opacity },
							uScanY: { value: 0 }
						},
						vertexShader: `
							varying float vH;
							void main() {
								vec4 wp = modelMatrix * vec4(position, 1.0);
								gl_Position = projectionMatrix * viewMatrix * wp;
								vH = uv.y;
							}
						`,
						fragmentShader: `
							varying float vH;
							uniform vec3 uColor;
							uniform float uOpacity;
							uniform float uScanY;
							void main() {
								// 底部深 → 顶部透明
								float alpha = (1.0 - vH) * uOpacity;
								// 扫描亮线
								float dist = abs(vH - uScanY);
								float line = exp(-dist * dist * 400.0) * 0.8;
								alpha += line;
								alpha = clamp(alpha, 0.0, 1.0);
								gl_FragColor = vec4(uColor * 1.3, alpha);
							}
						`,
						transparent: true,
						blending: THREE.AdditiveBlending,
						depthWrite: false,
						side: THREE.DoubleSide
					});

					if (!this._fenceMats) this._fenceMats = [];
					for (const { ax, ay, bx, by } of walls) {
						const verts = new Float32Array([
							ax, zBot, ay,  bx, zBot, by,  bx, zTop, by,
							ax, zBot, ay,  bx, zTop, by,  ax, zTop, ay,
						]);
						const uvs = new Float32Array([0,0, 1,0, 1,1, 0,0, 1,1, 0,1]);
						const geo = new THREE.BufferGeometry();
						geo.setAttribute('position', new THREE.BufferAttribute(verts, 3));
						geo.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));
						const m = new THREE.Mesh(geo, mat);
						targetMesh.add(m);
						this._fenceMats.push(mat);
					}
					// console.log(`✅ "${meshName}" 电子围栏已创建`);

				} catch (err) {
					console.error(`❌ addFenceWall("${meshName}") 异常:`, err);
				}
			},

			// 3D 标注点：立柱+发光球+HTML标签
			addAnnotationMarker(position, text, colorHex = '#4aa7ff') {
				if (!this.model || !this.scene) return;

				const group = new THREE.Group();
				const color = new THREE.Color(colorHex);

			// — 底座小环 —
			const ringGeo = new THREE.TorusGeometry(0.05, 0.03, 16, 32);
			const ringMat = new THREE.MeshStandardMaterial({
				color,
				emissive: color,
				emissiveIntensity:0,
				roughness:1,
				metalness: 1
			});
			const ring = new THREE.Mesh(ringGeo, ringMat);
			ring.rotation.x = Math.PI / 2;
			ring.position.y = 0.05;
			group.add(ring);

			// — 立柱（虚线，用小圆柱段拼接，避免 LineDashedMaterial shader 问题） —
			const poleHeight = 5;
			const dashSize = 0.3;   // 每段实线长度
			const gapSize = 0.2;    // 间隔长度
			const period = dashSize + gapSize;
			const segCount = Math.floor(poleHeight / period);
			const poleMat = new THREE.MeshBasicMaterial({ color: colorHex });
			for (let i = 0; i < segCount; i++) {
				const segGeo = new THREE.CylinderGeometry(0.02, 0.02, dashSize, 8);
				const seg = new THREE.Mesh(segGeo, poleMat);
				seg.position.y = i * period + dashSize / 2;
				group.add(seg);
			}
			// 末尾不足一个周期的剩余部分
			const remainder = poleHeight - segCount * period;
			if (remainder > 0.02) {
				const segGeo = new THREE.CylinderGeometry(0.02, 0.02, remainder, 8);
				const seg = new THREE.Mesh(segGeo, poleMat);
				seg.position.y = segCount * period + remainder / 2;
				group.add(seg);
			}

				// — CSS2D 标签 —
				const labelDiv = document.createElement('div');
				labelDiv.className = 'marker-label';
				const cardDiv = document.createElement('div');
				cardDiv.className = 'marker-label-card';
				cardDiv.innerHTML = `
						<div class="marker-label-title">${text}</div>
						<div class="marker-label-data">正常</div>
				`;
				cardDiv.addEventListener('click', (e) => {
					e.stopPropagation();
					this.textClick(text)
				});
				labelDiv.appendChild(cardDiv);
				const label = new CSS2DObject(labelDiv);
				label.position.set(0, poleHeight + 1.5, 0);
				group.add(label);

				group.position.copy(position);
				group.userData = { annotationName: text, annotationColor: colorHex };
				this.model.add(group);

				this.markerAnnotations.push({
					group,
					poleMat,
					ringMat,
					cardDiv,
					dataDiv: cardDiv.querySelector('.marker-label-data'),
					name: text
				});
			},
		textClick(text){
			this.menuIndex = 1;
			if (this.areaData && this.areaData.areas) {
				const area = this.areaData.areas.find(a => a.areaName === text);
				if (area) this.footerIndex = area.areaId;
			} else {
				this.pendingAreaName = text;
			}

			// 标记本次点击是否进入透明模式（即是否有 mesh 被设为 0.075 半透明）
			let enteredTransparent = false;

			if(text == '园区大门'){
				console.log('园区大门')
				this.setMeshesOpacity(['网格314','网格314_1','网格314_2','网格314_3','网格314_4','网格320','网格320_1','1-ceng-1','xiangzi','Rectangle266','langan','louding','logo','louding-2','1-ceng-2','1-cneg-waiqiang','2-ceng-002','2-ceng-waiqiang','3-ceng-','3-ceng-1','网格318','网格318_1','网格318_2','网格318_3','网格318_5'], 1);
				this.switchView('gate');
			}
			if(text == '天台'){
				console.log('天台')
				this.setMeshesOpacity(['网格314','网格314_1','网格314_2','网格314_3','网格314_4','网格320','网格320_1','1-ceng-1','xiangzi','Rectangle266','langan','louding','logo','louding-2','1-ceng-2','1-cneg-waiqiang','2-ceng-002','2-ceng-waiqiang','3-ceng-','3-ceng-1','网格318','网格318_1','网格318_2','网格318_3','网格318_5'], 1);
				this.switchView('tiantai');
			}
			if(text == '主机房'){
				console.log('主机房');
				this.setMeshesOpacity(['Rectangle266',], 1);
				this.setMeshesOpacity(['网格314','网格314_1','网格314_2','网格314_3','网格314_4','网格320','网格320_1','1-ceng-1','xiangzi','langan','louding','logo','louding-2','1-ceng-2','1-cneg-waiqiang','2-ceng-002','2-ceng-waiqiang','3-ceng-','3-ceng-1','网格318','网格318_1','网格318_2','网格318_3','网格318_5'], 0.075);
				this.switchView('jifang');
				enteredTransparent = true;
			}
			if(text == '仓库'){
				this.setMeshesOpacity(['网格320','网格320_1'], 1);
				this.setMeshesOpacity(['网格314','网格314_1','网格314_2','网格314_3','网格314_4','1-ceng-1','Rectangle266','langan','louding','logo','louding-2','1-ceng-2','1-cneg-waiqiang','2-ceng-002','2-ceng-waiqiang','3-ceng-','3-ceng-1','网格318','网格318_1','网格318_2','网格318_3','网格318_5'], 0.075);
				console.log('仓库')
				this.switchView('kufang');
				enteredTransparent = true;
			}
			if(text == '泵房'){
				this.setMeshesOpacity(['1-ceng-1','网格314','网格314_1','网格314_2','网格314_3','网格314_4'], 1);
				this.setMeshesOpacity(['网格320','网格320_1','Rectangle266','xiangzi','langan','louding','logo','louding-2','1-ceng-2','1-cneg-waiqiang','2-ceng-002','2-ceng-waiqiang','3-ceng-','3-ceng-1','网格318','网格318_1','网格318_2','网格318_3','网格318_5'], 0.075);
				console.log('泵房')
				this.switchView('bengfang');
				enteredTransparent = true;
			}

			// 进入透明模式 → 同步 opcty 状态 + 显示设备发光点（与"透明模式"按钮行为一致）
			if (enteredTransparent) {
				this.opcty = false;
				if (this.deviceGlowHalos) {
					this.deviceGlowHalos.forEach(h => h.visible = true);
				}
			}
		},
			setMeshesOpacity(names, opacity) {
				if (!this.model) return;
				this.model.traverse(child => {
					if (child.isMesh && names.includes(child.name)) {
						const mats = Array.isArray(child.material) ? child.material : [child.material];
						mats.forEach(mat => {
							mat.transparent = true;
							mat.opacity = opacity;
							mat.needsUpdate = true;
						});
						// console.log(`透明度已调整: ${child.name} → ${opacity}`);
					}
				});
			},
		getOptinty(){
			if(!this.opcty){
				this.setMeshesOpacity(['langan','louding','logo','louding-2','1-ceng-2','1-cneg-waiqiang','2-ceng-002','2-ceng-waiqiang','3-ceng-','3-ceng-1','网格318','网格318_1','网格318_2','网格318_3','网格318_5'], 1);
				// 恢复不透明模式 → 隐藏发光点
				if (this.deviceGlowHalos) {
					this.deviceGlowHalos.forEach(h => h.visible = false);
				}
			}else{
				this.setMeshesOpacity(['langan','louding','logo','louding-2','1-ceng-2','1-cneg-waiqiang','2-ceng-002','2-ceng-waiqiang','3-ceng-','3-ceng-1','网格318','网格318_1','网格318_2','网格318_3','网格318_5'], 0.075);
				// 透明模式 → 显示发光点
				if (this.deviceGlowHalos) {
					this.deviceGlowHalos.forEach(h => h.visible = true);
				}
			}
		this.opcty = !this.opcty
	},
	// 纯净模型：隐藏左右内容区，只看 3D 模型；再次点击恢复
	togglePureModel() {
		this.pureModel = !this.pureModel;
	},
	menuClick(item, index) {
			this.menuIndex = index;
			// 纯净模型只在园区总览（index===1）生效，切到其他菜单自动还原
			if (index !== 1 && this.pureModel) {
				this.pureModel = false;
			}
			console.log(index)
		},
		footerClick(item) {
			this.footerIndex = item.areaId;
			// 反向联动：组件点击 tab → 触发对应标注点的视角切换 + 透明度逻辑
			this.textClick(item.areaName);
		},

		// 视角切换：free=回到起始视角，gate=大门视角，tiantai=天台视角（带平滑过渡）
		switchView(type) {
			if (this.cameraAnimating || !this.camera || !this.controls) return;

			let targetPos, endTarget;
			if (type === 'free') {
				targetPos = new THREE.Vector3(this.initialCameraPos.x, this.initialCameraPos.y, this.initialCameraPos.z);
				endTarget = new THREE.Vector3(this.initialTarget.x, this.initialTarget.y, this.initialTarget.z);
			} else if (type === 'gate') {
				targetPos = new THREE.Vector3(this.gateCameraPos.x, this.gateCameraPos.y, this.gateCameraPos.z);
				endTarget = new THREE.Vector3(this.gateTarget.x, this.gateTarget.y, this.gateTarget.z);
			} else if (type === 'tiantai') {
				targetPos = new THREE.Vector3(this.tiantaiCameraPos.x, this.tiantaiCameraPos.y, this.tiantaiCameraPos.z);
				endTarget = new THREE.Vector3(this.tiantaiTarget.x, this.tiantaiTarget.y, this.tiantaiTarget.z);
			} else if (type === 'jifang') {
				targetPos = new THREE.Vector3(this.jifangCameraPos.x, this.jifangCameraPos.y, this.jifangCameraPos.z);
				endTarget = new THREE.Vector3(this.jifangTarget.x, this.jifangTarget.y, this.jifangTarget.z);
			} else if (type === 'kufang') {
				targetPos = new THREE.Vector3(this.kufangCameraPos.x, this.kufangCameraPos.y, this.kufangCameraPos.z);
				endTarget = new THREE.Vector3(this.kufangTarget.x, this.kufangTarget.y, this.kufangTarget.z);
			} else if (type === 'bengfang') {
				targetPos = new THREE.Vector3(this.bengfangCameraPos.x, this.bengfangCameraPos.y, this.bengfangCameraPos.z);
				endTarget = new THREE.Vector3(this.bengfangTarget.x, this.bengfangTarget.y, this.bengfangTarget.z);
			} else {
				return;
			}

			// 更新自由视角按钮 active 状态
			const btnFree = this.$el.querySelector('#btn-free');
			if (btnFree) btnFree.classList.toggle('active', type === 'free');

			const startPos = this.camera.position.clone();
			const startTarget = this.controls.target.clone();
			const duration = 1200; // 过渡时长 ms
			const startTime = performance.now();

			this.cameraAnimating = true;
			// 过渡期间禁用控制器，避免手动拖拽打断插值
			this.controls.enabled = false;

			// 三次方缓入缓出
			const easeInOutCubic = (t) =>
				t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

			const step = () => {
				const elapsed = performance.now() - startTime;
				const t = Math.min(elapsed / duration, 1);
				const eased = easeInOutCubic(t);

				this.camera.position.lerpVectors(startPos, targetPos, eased);
				this.controls.target.lerpVectors(startTarget, endTarget, eased);
				this.controls.update();

				if (t < 1) {
					requestAnimationFrame(step);
				} else {
					this.cameraAnimating = false;
					this.controls.enabled = true;
					this.controls.update();
				}
			};
			requestAnimationFrame(step);
		},

		// 人员进出记录条目点击：切到园区大门视角（子组件 parkOverviewRight 触发）
		onAccessItemClick(item) {
			console.log('[model] 人员进出记录点击，切换到大门视角:', item)
			this.switchView('gate')
		},

		// 采集当前视角（打印 + 弹窗显示 camera.position 和 controls.target，方便查看/复制）
		captureView() {
			if (!this.camera || !this.controls) {
				console.warn('相机或控制器未就绪');
				return;
			}
			const pos = this.camera.position;
			const tgt = this.controls.target;
			const cameraObj = { x: pos.x, y: pos.y, z: pos.z };
			const targetObj = { x: tgt.x, y: tgt.y, z: tgt.z };
			console.log('📷 当前视角已采集:');
			console.log('  Camera:', cameraObj);
			console.log('  Target:', targetObj);
			alert(
				'当前视角已采集！\n\n' +
				'Camera:\n' + JSON.stringify(cameraObj) + '\n\n' +
				'Target:\n' + JSON.stringify(targetObj)
			);
		},

		// 标注点点击事件
			onAnnotationClick(event) {
				if (!this.raycaster || !this.camera || !this.model || !this.markerAnnotations.length) return;
				// 用 offsetX/offsetY 直接计算，避免 getBoundingClientRect 误差
				const container = document.getElementById("container");
				if (!container) return;
				this.mouse.x = (event.offsetX / container.clientWidth) * 2 - 1;
				this.mouse.y = -(event.offsetY / container.clientHeight) * 2 + 1;
				this.raycaster.setFromCamera(this.mouse, this.camera);

				// 1. 先精确射线检测：射线穿过模型 mesh
				const intersects = this.raycaster.intersectObject(this.model, true);
				if (intersects.length > 0) {
					const hit = intersects[0];
					const mesh = hit.object;
					// 优先用 mesh 自身 name，没有就向上找父级 name
					let name = mesh.name;
					let parent = mesh.parent;
					while (!name && parent) {
						name = parent.name;
						parent = parent.parent;
					}
					console.log('点击了模型:', name);

					// 查映射表，匹配到则弹框
					const deviceInfo = this.deviceMeshMap[name];
					if (deviceInfo) {
						this.deviceModal.deviceInfo = { ...deviceInfo, meshName: name };
						this.deviceModal.visible = true;
						return; // 精确命中设备，直接返回
					}
				}

				// 2. 精确射线没命中设备 → 球体容差拾取
				// 小模型（摄像头/传感器）远处只占几像素，射线很难精确穿过
				// 改为计算射线到每个设备 mesh 世界坐标的距离，小于阈值则算命中
				// 阈值按相机距离动态调整，屏幕上容差范围大致恒定
				const deviceNames = Object.keys(this.deviceMeshMap);
				const ray = this.raycaster.ray;
				const cameraPos = this.camera.position;
				const candidates = [];
				const tmpPos = new THREE.Vector3();

				this.model.traverse((child) => {
					if (!child.isMesh) return;
					if (deviceNames.indexOf(child.name) === -1) return;
					child.getWorldPosition(tmpPos);
					// 射线到设备点的垂直距离
					const rayDist = ray.distanceToPoint(tmpPos);
					// 相机到设备的距离
					const camDist = cameraPos.distanceTo(tmpPos);
					// 阈值：相机距离的 3.5%（远处大近处小，屏幕容差恒定）
					const threshold = camDist * 0.035;
					if (rayDist < threshold) {
						candidates.push({ name: child.name, rayDist, camDist });
					}
				});

				if (candidates.length > 0) {
					// 取射线距离最小的（最接近点击位置）
					candidates.sort((a, b) => a.rayDist - b.rayDist);
					const best = candidates[0];
					console.log('容差命中设备:', best.name, '射线距离:', best.rayDist.toFixed(3), '阈值:', (best.camDist * 0.035).toFixed(3));
					const deviceInfo = this.deviceMeshMap[best.name];
					if (deviceInfo) {
						this.deviceModal.deviceInfo = { ...deviceInfo, meshName: best.name };
						this.deviceModal.visible = true;
					}
				}
			},
			
		},
	};
</script>

<style scoped lang="scss">
	.model {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		position: relative;
		background: #000;
	}

	.video-mask {
		position: fixed;
		inset: 0;
		z-index: 99999;
		background: #000;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		.intro-video {
			width: 100vw;
			height: 100vh;
			object-fit: cover;
			display: block;
		}

		.skip-tip {
			position: absolute;
			bottom: 20px;
			right: 20px;
			color: #B3C8DC;
			font-size: 14px;
			background: rgba(0, 0, 0, 0.5);
			padding: 8px 16px;
			border-radius: 4px;
		}
	}

	.container {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		opacity: 0;
		transform: scale(0.8);
		/* 移除过渡延迟，即时响应 */
	}

	.header {
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		padding: 10px 20px;
		min-height: 80px;
		background: rgba(9, 23, 36, 0.9);
		box-shadow: 0px 1px 0px 0px rgba(38, 71, 102, 0.3);
		opacity: 0;
	}

	.logo-box {
		.name {
			font-size: clamp(18px, 2vw, 24px);
			color: #B3C8DC;
			font-weight: bold;
		}

		.english {
			font-size: clamp(10px, 1vw, 12px);
			color: #B3C8DC;
			letter-spacing: 3px;
			margin-top: 8px;
		}
	}

	.menu-box {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);

		.menu-item {
			width: clamp(120px, 10vw, 160px);
			height: 24px;
			font-size: clamp(14px, 1.2vw, 18px);
			color: #B3C8DC;
			text-align: center;
			border-right: 1px solid #25394C;
			cursor: pointer;

			.active-img {
				width: clamp(120px, 10vw, 160px);
				margin-top: -10px;
			}
		}

		.last-menu-item {
			border: none;
		}

		.active {
			color: #94CBFF;
		}
	}

	.weather {
		padding: 0 clamp(8px, 1vw, 12px);
		border-radius: 50px;
				// border: 1px solid #4578A8;
		font-size: clamp(10px, 1vw, 12px);
		color: #B3C8DC;
		letter-spacing: 1px;
		margin-left: 10px;

		.icon {
			width: 16px;
			height: 16px;
			margin-right: 5px;
		}

		.line {
			width: 1px;
			height: 12px;
			margin: 0 clamp(10px, 2vw, 20px);
			background-color: #B3C8DC;
		}
	}

	.content-wrapper {
		width: 100%;
		height: 100%;


		.content-left,
		.content-right {
			position: relative;
			z-index: 2;
		}

		.content-left {
			left: 0;
		}

		.content-right {
			right: 0;
		}
	}

	/* 返回按钮 */
	.back-btn {
		position: absolute;
		top: 90px;
		left: 20px;
		z-index: 100;
		padding: 8px 18px;
		background: rgba(10, 20, 40, 0.85);
		border: 1.5px solid #4488ff;
		border-radius: 6px;
		color: #94CBFF;
		font-size: 14px;
		cursor: pointer;
		user-select: none;
		letter-spacing: 1px;
	}
	.back-btn:hover {
		background: rgba(30, 60, 120, 0.9);
		border-color: #66aaff;
	}

	.controls {
      position: fixed;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 20px;
      z-index: 100;
    }
    
    .btn {
      padding: 14px 32px;
      border: none;
      border-radius: 12px;
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
      backdrop-filter: blur(20px);
    }
    
    .btn-free {
      background: rgba(255,255,255,0.1);
      color: #fff;
      border: 1px solid rgba(255,255,255,0.2);
    }
    .btn-free:hover { background: rgba(255,255,255,0.2); transform: translateY(-2px); }
    .btn-free.active { background: rgba(100,149,237,0.3); border-color: #6495ed; }

    .btn-capture {
      background: rgba(255,165,0,0.15);
      color: #ffcc66;
      border: 1px solid rgba(255,165,0,0.4);
    }
    .btn-capture:hover { background: rgba(255,165,0,0.3); transform: translateY(-2px); }

    .btn-pure {
      background: rgba(74,167,255,0.12);
      color: #7ABFFF;
      border: 1px solid rgba(74,167,255,0.35);
    }
    .btn-pure:hover { background: rgba(74,167,255,0.25); transform: translateY(-2px); }
    .btn-pure.active { background: rgba(54,209,255,0.3); border-color: #36d1ff; color: #36d1ff; }

    .btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none !important; }
    
</style>

<style>
/* 3D 标注标签样式 — 全局（CSS2DObject 脱离 Vue 组件树） */
.marker-label {
	pointer-events: none;
	display: flex;
	flex-direction: column;
	align-items: center;
	transform: translateY(-50%);
}
.marker-label-card {
	/* width: 120px; */
	/* min-width: 110px; */
	/* text-align: center; */
	padding: 10px 16px 12px;
	pointer-events: auto;
	cursor: pointer;
	background: rgb(9 23 36 / 57%);
	/* background: linear-gradient(135deg, rgba(12, 25, 48, 0.95), rgba(8, 18, 38, 0.98)); */
	border: 1px solid #4aa7ff;
	border-radius: 6px;
	/* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.05); */
	/* white-space: nowrap; */
	/* backdrop-filter: blur(8px); */
}
.marker-label-title {
	font-size: 14px;
	font-weight: 600;
	color: #E8F0FE;
	letter-spacing: 2px;
	margin-bottom: 6px;
	/* text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5); */
}
.marker-label-data {
	font-size: 10px;
	color: #4aa7ff;
	letter-spacing: 1px;
}
</style>